export default __webpack_public_path__ + "static/01_Rat-4e8a0b83d558e6ed8af6fc81f631c36e.png";